import {
  createCommandAsyncThunk,
  createQueryAsyncThunk,
} from "../../../app/createApiAsyncThunk";
import {
  hrTaskAck,
  hrTaskListQuery,
  talentsDashboardCountsQuery,
} from "../dashboardApi";
import {
  HrTaskAck,
  HrTaskAcknowledged,
  HrTasklistkRows,
  HrTasklistQuery,
} from "../tasklist/types";
import { DashboardTalentCounts } from "../talents/types";

export const fetchHrTasklist = createQueryAsyncThunk<
  HrTasklistkRows,
  HrTasklistQuery
>("dashboard/fetchHrTasklist", hrTaskListQuery);

export const fetchMoreHrTasks = createQueryAsyncThunk<
  HrTasklistkRows,
  HrTasklistQuery
>("dashboard/fetchMoreHrTasks", hrTaskListQuery);

export const hrTaskAcknowledge = createCommandAsyncThunk<
  HrTaskAck,
  HrTaskAcknowledged
>("dashboard/hrTaskAcknowledge", hrTaskAck);

export const talentsDashboardCounts = createQueryAsyncThunk<
  DashboardTalentCounts,
  {}
>("dashboard/talentsDashboardCounts", talentsDashboardCountsQuery);
